<form class="pessoa-termo-lgpd-form" #form="ngForm" novalidate>
    <ng-template [ngIf]="isLoading">
        <p class="pessoa-termo-lgpd-form-loading">
            <i class='fas fa-spinner fa-pulse' aria-hidden='true'></i> Carregando Termo LGPD
        </p>
    </ng-template>

    <ng-template [ngIf]="entity">
        <div class="row pessoa-termo-lgpd-form-status">
            <div class="col-12">
                <label class="col-form-label d-block p-0">Status</label>
                <sgt-pessoa-termo-lgpd-status-badge
                    [status]="entity.status">
                </sgt-pessoa-termo-lgpd-status-badge>
            </div>
        </div> 
        
        <div class="row pessoa-termo-lgpd-form-alerts">
            <div class="col-12">
                <div class="alert" role="alert"
                    [ngClass]="{'alert-warning alert-pendente': config?.isStatusPendente,
                                'alert-info alert-impresso': config?.isStatusImpresso,
                                'alert-success alert-anexado': config?.isStatusAnexado}">

                    <p *ngIf="config?.isStatusPendente || config?.isStatusImpresso">
                        Siga os passos abaixo para imprimir, coletar e anexar o Termo LGPD do cliente:
                    </p>

                    <!-- Impresso -->
                    <div class="alert-block">
                        <ng-template [ngIf]="!entity.idUsuarioImpressao">
                            <i class="far fa-hand-point-right"></i> Imprima o Termo LGPD;
                        </ng-template>
                        <ng-template [ngIf]="entity.idUsuarioImpressao">
                            <i class="fas fa-check"></i> Termo LGPD impresso em {{entity.dataImpressao | date:'dd/MM/yyyy HH:mm:ss'}} por {{entity.nomeUsuarioImpressao}};
                        </ng-template>
                    </div>
                    
                    <!-- Anexado -->
                    <div class="alert-block">
                        <ng-template [ngIf]="!entity.idUsuarioAnexo">
                            <i class="far fa-circle" *ngIf="config?.isStatusPendente"></i>
                            <i class="far fa-hand-point-right" *ngIf="config?.isStatusImpresso"></i>
                            Colete a assinatua do cliente e/ou responsáveis e anexe o Termo LGPD assinado.
                        </ng-template>
                        <ng-template [ngIf]="entity.idUsuarioAnexo">
                            <i class="fas fa-check"></i> Termo LGPD anexado em {{entity.dataAnexo | date:'dd/MM/yyyy HH:mm:ss'}} por {{entity.nomeUsuarioAnexo}}.                             
                        </ng-template>                        
                    </div>  
                    
                    <div class="alert-options">
                        <button *ngIf="config?.canImprimirNovamente" type="button" class="btn btn-link btn-imprimir" (click)="imprimirClick()">
                            <i class="fas fa-print"></i> Imprimir Novamente
                        </button>

                        <button *ngIf="config?.canDelete" type="button" class="btn btn-link btn-link-delete" (click)="delete()">
                            <i class="far fa-trash-alt"></i> Remover Termo LGPD
                        </button>                         
                    </div>
                </div>                                
            </div>
        </div>
        
        <div class="row pessoa-termo-lgpd-form-options">
            <div class="col-12">
                <!-- Imprimir Termo -->
                <button *ngIf="config?.canImprimir && !config?.canImprimirNovamente" type="button" class="btn btn-light btn-imprimir" (click)="imprimirClick()">
                    <i class="fas fa-print"></i> Imprimir Termo LGPD
                </button>
        
                <!-- Anexar Termo -->
                <sgt-pessoa-termo-lgpd-file-upload
                    *ngIf="config?.canAnexar"
                    [entity]="entity"
                    (entityChange)="onChangeEntity($event)">
                </sgt-pessoa-termo-lgpd-file-upload>
                
                <!-- Abrir Anexo -->
                <a *ngIf="config?.canOpenAnexo" class="btn btn-light" [href]="entity.urlAnexo" title="Abrir Termo LGPD" target="_blank">
                    <i class="fas fa-external-link-alt"></i> Abrir Termo LGPD
                </a>          
            </div>
        </div>
    </ng-template>
</form>